import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { ActionSearchDto, AtonUnit } from "~/api/GeneratedApi";
import AtoNActionsTab from "~/pages/aton-units-page/tabs/AtoNActionsTab";
import {
  actionTypesDefaultValues,
  ActionTypesForm,
  ActionTypesFormTypes,
} from "../ActionSearchContainers/ActionTypesForm";
import {
  TimeAndStateForm,
  timeAndStateFormDefaultValues,
  TimeAndStateFormTypes,
} from "../ActionSearchContainers/TimeAndStateForm";
import {
  FeaturesForm,
  featuresFormDefaultValues,
  FeaturesFormTypes,
} from "../AtonSearchFormContainers/FeaturesForm";
import {
  LocationAndResponsibilityForm,
  locationAndResponsibilityFormDefaults,
  LocationAndResponsibilityFormProps,
} from "../AtonSearchFormContainers/LocationAndResponsibilityForm";
import {
  StateAndTypeForm,
  stateAndTypeFormDefaults,
  StateAndTypeFormTypes,
} from "../AtonSearchFormContainers/StateAndTypeForm";
import { GenericSearchPage } from "../GenericSearchPage";
import { useActionSearch } from "../hooks/useActionSearch";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type ActionsTabFormData = TimeAndStateFormTypes &
  LocationAndResponsibilityFormProps &
  ActionTypesFormTypes &
  // ActionFormDefaultTypes &
  StateAndTypeFormTypes &
  FeaturesFormTypes;

const defaultValues: ActionsTabFormData = {
  // ...actionFormDefaultValues,

  ...actionTypesDefaultValues,

  ...timeAndStateFormDefaultValues,
  ...stateAndTypeFormDefaults,

  ...featuresFormDefaultValues,

  ...locationAndResponsibilityFormDefaults,
};

export const formToDto = (
  form: ActionsTabFormData | undefined,
): ActionSearchDto | undefined => {
  if (!form) return undefined;

  return {
    ...form,
    actions: (form.actions?.map((c) => c.actioN_CDE) as number[]) ?? undefined,
    workCategory: form.workCategory?.actioN_CDE ?? undefined,
    workClasses:
      (form.workClasses?.map((c) => c.actioN_CDE) as number[]) ?? undefined,
    state: form.state?.actioN_CDE ?? undefined,
  } as unknown as ActionSearchDto;
};

export const ActionsTab = ({ isDisabled }: SharedFormProps): JSX.Element => {
  const { t } = useTranslation("securityDeviceSearch");
  const [searchOptions, setSearchOptions] = React.useState<
    ActionsTabFormData | undefined
  >();

  const { actions, isLoading } = useActionSearch({
    options: formToDto(searchOptions),
  });

  const searchForms = React.useMemo(
    () => [
      // {
      //   title: t("measures"),
      //   children: <ActionsForm isDisabled={isDisabled} />,
      // },
      {
        title: t("actionSearch:actionType"),
        children: <ActionTypesForm isDisabled={isDisabled} />,
      },
      {
        title: t("faultSearch:timeAndStateForm"),
        children: <TimeAndStateForm isDisabled={isDisabled} />,
      },
      {
        title: t("actionSearch:title"),
        children: (
          <>
            <StateAndTypeForm isDisabled={isDisabled} />
            <FeaturesForm isDisabled={isDisabled} />
          </>
        ),
      },
      {
        title: t("faultSearch:atonLocationAndRenponsibility"),
        children: <LocationAndResponsibilityForm isDisabled={isDisabled} />,
      },
    ],
    [isDisabled, t],
  );

  const atonUnits = React.useMemo(() => {
    const units: AtonUnit[] = [];
    actions?.forEach((a) => {
      if (a.atonUnit !== undefined) units.push(a.atonUnit);
    });
    return units;
  }, [actions]);

  const csvData = React.useMemo(() => {
    if (!actions) return [];
    return actions.map((a) => {
      return {
        Pvm: dayjs(a.timestamp).format("DD.MM.YYYY"),
        aika: dayjs(a.timestamp).format("HH:mm"),
        Toimenpide: a.type,
        Tila: a.state,
        Nro: a.atonUnit?.atonNumber ?? "",
        Nimi: a.atonUnit?.name ?? "",
        Tyyppi: a.atonUnit?.type ?? "",
        Lisätiedot: a.memo,
      };
    });
  }, [actions]);

  return (
    <GenericSearchPage<ActionsTabFormData>
      isDisabled={isDisabled}
      searchContainers={searchForms}
      defaultValues={defaultValues}
      tableContent={<AtoNActionsTab actionData={actions ?? []} />}
      pageTitle={t("fairwayReport:actions")}
      isLoading={isLoading}
      setSearchOptions={setSearchOptions}
      atonUnits={atonUnits}
      csvData={csvData}
    />
  );
};
